export default "__VITE_ASSET__Tb5rQKiq__"